import Vue from 'vue';
import Component from 'vue-class-component';
import Cookies from 'js-cookie';
import { PageModule } from '@/store/modules/modulesLoadModule';
import { GET_MODULES } from '@/store/modules/modulesLoadModule';
import cloneDeep from 'lodash/cloneDeep';
import { getStore } from '@/store';
import { Country } from '@/store/modules/metadataModule';

@Component({
  components: {
    NewsletterPopup: () => import('@/modules/NewsletterPopup/NewsletterPopup.vue'),
  },
})
export default class DownloadGateMixin extends Vue {
  downloadStarted = false;
  downloadLink = '';
  newsletterPopup: PageModule;
  gateName = 'BrochureGatingForm'
  created() {
    const newsletter: PageModule = this.$store.getters[GET_MODULES].find((m: PageModule) => m.Type === 'NewsletterPopup');
    const gateNewsletter = cloneDeep(newsletter);
    gateNewsletter.Data.GateName = this.gateName;

    const { Country: CountryId } = getStore().state.Meta;
    const NotWorldText = CountryId !== Country.WORLD ? '-National Geographic' : ''
    gateNewsletter.Data.Title = `Subscribe to receive emails from Lindblad Expeditions${NotWorldText} and look forward to receiving this brochure as well as the latest news, original stories and videos, exclusive offers and much more.*`;
    gateNewsletter.Data.ThankYouText = `Welcome to Lindblad Expeditions${NotWorldText}.`;
    this.newsletterPopup = gateNewsletter;
  }
  onNewsletterClosed() {
    this.downloadStarted = false
  }
  onDownloadClick(e, link: string, ShowSubscription: boolean = true) {
    if (!Cookies.get('newsletterSubscribed') && ShowSubscription) {
      e.preventDefault()
      this.downloadStarted = true
      this.downloadLink = link
      if (!this.newsletterPopup.Data.AnalyticsData) this.newsletterPopup.Data.AnalyticsData = {}
      this.newsletterPopup.Data.AnalyticsData.document_url = `${document.location.origin}${link}`

      if (!this.newsletterPopup.Data.AnalyticsData.brochures) {
        const brochureCardData = JSON.parse(e.target.parentElement.parentElement.querySelector('script[type="application/json"]').textContent)
        brochureCardData[0].image_url = `${document.location.origin}${brochureCardData[0].image_url}`
        brochureCardData[0].quantity = Number(brochureCardData[0].quantity)
        this.newsletterPopup.Data.AnalyticsData.brochures = brochureCardData
      }
    }
  }
  onNewsletterSubmitted() {
    let name: string;
    if (this.gateName.includes('Brochure')) {
      const path = this.downloadLink.split('/');
      name = path[path.length - 1]
    }
    const link = document.createElement('a');
    link.setAttribute('href', this.downloadLink);
    link.setAttribute('download', name ? name : 'download');
    link.click();
  }
}
